import React, { useContext, useEffect, useState } from "react";
import styled from "styled-components";
import { APIContext } from "../../contexts/APIContext";
import { ScrollBar } from "../../Theme/Hyper";

const Main = styled.div`
  display: flex;
  width: 100%;
`;
const Content = styled(ScrollBar)`
  display: flex;
  box-sizing: border-box;
  flex: 1;
  flex-wrap: wrap;
  justify-content: space-around;
  height: calc(100vh - 50px);
  overflow-y: auto;
`;

const Table = styled.table`
  width: 100%;
  background-color: #262d38;
  border-collapse: separate;
  border-spacing: 0;

  th {
    padding: 10px;
    border-top: 1px solid #dee2e6;
  }
  td {
    font-size: 14px;
    padding: 5px;
    padding-left: 5px;
    padding-right: 5px;
    border-top: 1px solid #37404a;
    width: ${(props) => props.width};
  }
`;

const TR = styled.tr`
  :nth-of-type(odd) {
    background-color: ${(props) =>
      props.selected ? "" : "rgba(0, 0, 0, 0.05)"};
  }
  background-color: ${(props) => (props.selected ? "#ed426f" : "")};
  color: white;
  cursor: pointer;
  :hover {
    background-color: #db0a41;
    color: white;
    cursor: pointer;
  }
`;

const TH = styled.th`
  border-top: 0;
  border-bottom: 0;
  font-weight: 800;
  font-size: 0.8em;
  text-transform: uppercase;
  color: #343a40;
  text-align: left;
`;

const Column = styled.div`
  diplay: flex;
  width: 22%;
  margin: 5px;
`;
const Title = styled.div`
  display: flex;
  height: 33px;
  align-content: center;
`;

const TeamName = styled.span`
  font-size: 12px;
`;

const PlayerName = styled.span`
  font-weight: bold;
`;
const List = styled.div`
  display: flex;
  flex-direction: column;
  height: 100vh;
  background-color: #262d38;
`;
const ListItem = styled.div`
  padding: 10px;
  border-top: 1px solid #37404a;
  background-color: ${(props) => (props.selected ? "#db0a41" : "")};
  :hover {
    background-color: ${(props) => (!props.selected ? "#353f4e" : "")};
    color: white;
    cursor: pointer;
  }
`;

export default function Stats() {
  const { getSeasonStats } = useContext(APIContext);
  const [stats, setStats] = useState([]);
  const [teams, setTeams] = useState([]);
  const [selectedTeam, setSelectedTeam] = useState("");
  const [hoverPlayer, setHoverPlayer] = useState("");

  useEffect(() => {
    getSeasonStats({}).then((data) => {
      let newTeams = [];
      for (let i = 0; i < data.length; i++) {
        if (newTeams.findIndex((t) => t._id === data[i]?.team?._id) === -1) {
          newTeams.push(data[i].team);
        }
      }

      setTeams(newTeams);
      setStats(JSON.parse(JSON.stringify(data)));
    });
  }, [getSeasonStats]);

  return (
    <Main>
      <List>
        <ListItem
          selected={selectedTeam === ""}
          onClick={() => setSelectedTeam("")}
        >
          All
        </ListItem>
        {teams?.map((team) => {
          return (
            <ListItem
              selected={selectedTeam === team._id}
              onClick={() => setSelectedTeam(team._id)}
            >
              {team?.name}
            </ListItem>
          );
        })}
      </List>
      <Content>
        <StatTable
          title={"Top Goal Scorers"}
          variable={"goals"}
          stats={stats}
          selectedTeam={selectedTeam}
          setHoverPlayer={setHoverPlayer}
          hoverPlayer={hoverPlayer}
        ></StatTable>
        <StatTable
          title={"Most Intercepts"}
          variable={"intercepts"}
          stats={stats}
          selectedTeam={selectedTeam}
          setHoverPlayer={setHoverPlayer}
          hoverPlayer={hoverPlayer}
        ></StatTable>
        <StatTable
          title={"Penalties"}
          variable={"penalties"}
          stats={stats}
          selectedTeam={selectedTeam}
          setHoverPlayer={setHoverPlayer}
          hoverPlayer={hoverPlayer}
        ></StatTable>
        <StatTable
          title={"Turnovers"}
          variable={"turnovers"}
          stats={stats}
          selectedTeam={selectedTeam}
          setHoverPlayer={setHoverPlayer}
          hoverPlayer={hoverPlayer}
        ></StatTable>
        <StatTable
          title={"Deflections"}
          variable={"deflections"}
          stats={stats}
          selectedTeam={selectedTeam}
          setHoverPlayer={setHoverPlayer}
          hoverPlayer={hoverPlayer}
        ></StatTable>
        <StatTable
          title={"Total Shots"}
          variable={"total_shots"}
          stats={stats}
          selectedTeam={selectedTeam}
          setHoverPlayer={setHoverPlayer}
          hoverPlayer={hoverPlayer}
        ></StatTable>
        <StatTable
          title={"Missed Shots"}
          variable={"missed_shots"}
          stats={stats}
          selectedTeam={selectedTeam}
          setHoverPlayer={setHoverPlayer}
          hoverPlayer={hoverPlayer}
        ></StatTable>
        <StatTable
          title={"Unforced Errors"}
          variable={"unforced_errors"}
          stats={stats}
          selectedTeam={selectedTeam}
          setHoverPlayer={setHoverPlayer}
          hoverPlayer={hoverPlayer}
        ></StatTable>
        <StatTable
          title={"Defensive Rebounds"}
          variable={"rebounds_defensive"}
          stats={stats}
          selectedTeam={selectedTeam}
          setHoverPlayer={setHoverPlayer}
          hoverPlayer={hoverPlayer}
        ></StatTable>
        <StatTable
          title={"Offensive Rebounds"}
          variable={"rebounds_offensive"}
          stats={stats}
          selectedTeam={selectedTeam}
          setHoverPlayer={setHoverPlayer}
          hoverPlayer={hoverPlayer}
        ></StatTable>
        <StatTable
          title={"Feeds"}
          variable={"feeds"}
          stats={stats}
          selectedTeam={selectedTeam}
          setHoverPlayer={setHoverPlayer}
          hoverPlayer={hoverPlayer}
        ></StatTable>
      </Content>
    </Main>
  );
}

function StatTable({
  title,
  variable,
  stats,
  selectedTeam,
  setHoverPlayer,
  hoverPlayer,
}) {
  function getTotal({ variable, stats }) {
    return stats.reduce((prev, curr) => {
      return prev + (parseInt(curr.season_stats?.[variable]) || 0);
    }, 0);
  }
  return (
    <Column>
      <Title>
        {title}
        {/* {getTotal({ stats, variable })} */}
      </Title>
      <Table>
        <tbody>
          {stats
            ?.filter((s) => selectedTeam === "" || s.team?._id === selectedTeam)
            ?.sort(
              (a, b) =>
                (b.season_stats?.[variable] || 0) -
                (a.season_stats?.[variable] || 0)
            )
            ?.slice(0, 10)
            ?.map((player, index) => {
              return (
                <TR
                  onMouseEnter={() => {
                    setHoverPlayer(player?.player?._id);
                  }}
                  onMouseLeave={() => {
                    setHoverPlayer();
                  }}
                  selected={false}
                >
                  <td>{index + 1}</td>
                  <td>
                    <PlayerName>
                      {player?.player?.first_name} {player?.player?.last_name}
                    </PlayerName>
                    <br />
                    <TeamName>{player?.team?.name}</TeamName>
                  </td>
                  <td>{player?.season_stats?.[variable] || 0}</td>
                </TR>
              );
            })}
        </tbody>
      </Table>
    </Column>
  );
}
